import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Button, Menu, MenuItem, Radio, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
export const SelectWithRadio = ({ options, value, onChange, defaultValue = '', placeholder = 'Select option', minWidth = 150, disabled = false, label, error = false, helperText, fullWidth = false, // Default to false
 }) => {
    const [internalValue, setInternalValue] = useState(defaultValue);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const isControlled = value !== undefined;
    const selectedValue = isControlled ? value : internalValue;
    const handleClick = (event) => {
        if (!disabled) {
            setAnchorEl(event.currentTarget);
        }
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleSelect = (optionValue) => {
        if (!isControlled) {
            setInternalValue(optionValue);
        }
        onChange?.(optionValue);
        handleClose();
    };
    const selectedLabel = options.find(opt => opt.value === selectedValue)?.label || placeholder;
    return (_jsxs(Box, { sx: { width: fullWidth ? '100%' : 'auto' }, children: [label && (_jsx(Typography, { variant: "body1", sx: theme => ({
                    mb: 0.5,
                    color: error
                        ? theme.palette.error.main
                        : theme.palette.text.secondary,
                    fontWeight: 500,
                }), children: label })), _jsx(Button, { variant: "outlined", onClick: handleClick, endIcon: _jsx(KeyboardArrowDownIcon, {}), disabled: disabled, fullWidth: fullWidth, sx: theme => ({
                    textTransform: 'none',
                    fontSize: 14,
                    color: selectedValue
                        ? theme.palette.text.primary
                        : theme.palette.text.secondary,
                    borderColor: error ? theme.palette.error.main : theme.palette.divider,
                    bgcolor: theme.palette.background.paper,
                    minWidth,
                    justifyContent: 'space-between',
                    py: 1,
                    '&:hover': {
                        borderColor: error
                            ? theme.palette.error.main
                            : theme.palette.primary.main,
                        bgcolor: theme.palette.background.paper,
                    },
                    '&.Mui-disabled': {
                        bgcolor: theme.palette.action.disabledBackground,
                    },
                }), children: selectedLabel }), helperText && (_jsx(Typography, { variant: "caption", sx: theme => ({
                    mt: 0.5,
                    ml: 1.75,
                    display: 'block',
                    color: error
                        ? theme.palette.error.main
                        : theme.palette.text.secondary,
                }), children: helperText })), _jsx(Menu, { anchorEl: anchorEl, open: open, onClose: handleClose, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                }, slotProps: {
                    paper: {
                        sx: {
                            minWidth: typeof minWidth === 'number' ? `${minWidth}px` : minWidth,
                            maxHeight: 400,
                            mt: 0.5,
                        },
                    },
                }, children: options.map(option => (_jsx(MenuItem, { onClick: () => handleSelect(option.value), selected: selectedValue === option.value, sx: theme => ({
                        py: 1.5,
                        px: 2,
                        borderBottom: `1px solid ${theme.palette.divider}`,
                        '&:last-child': {
                            borderBottom: 'none', // Remove border from last item
                        },
                        '&.Mui-selected': {
                            bgcolor: theme.palette.action.selected,
                            '&:hover': {
                                bgcolor: theme.palette.action.selected,
                            },
                        },
                    }), children: _jsxs(Box, { sx: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.5,
                            width: '100%',
                        }, children: [_jsx(Radio, { checked: selectedValue === option.value, sx: theme => ({
                                    p: 0,
                                    color: theme.palette.action.active,
                                    '&.Mui-checked': {
                                        color: theme.palette.primary.main,
                                    },
                                }) }), _jsx(Typography, { variant: "body1", sx: { flex: 1, fontWeight: 400 }, children: option.label })] }) }, option.value))) })] }));
};
